import { FadeUp } from "@/components/Reveal";

const sections = [
  {
    title: "What we collect",
    body: "When you join the ApiaryKeeper launch list, we collect your first name, email address, and the beekeeping details you choose to share (hive count, record-keeping method, interests, and referral information). We collect only what you give us directly.",
  },
  {
    title: "How we use it",
    body: "We use your information to send launch updates, early access invitations, and beta testing opportunities, and to shape ApiaryKeeper around what beekeepers actually need. Referral information is used solely to operate the referral rewards program.",
  },
  {
    title: "Marketing consent",
    body: "Emails are only sent to launch list members who opted in. Every marketing email includes an unsubscribe option, and you can withdraw consent at any time by contacting us.",
  },
  {
    title: "What we never do",
    body: "We never sell your information, never share it with advertisers, and never ask for passwords or payment details by email.",
  },
  {
    title: "Your choices",
    body: "You may request a copy, correction, or deletion of your information at any time by emailing support@apiarykeeper.com.",
  },
  {
    title: "Contact",
    body: "ApiaryKeeper is a product of Herrell Interactive (Herrell Homestead LLC). Questions about this policy: support@apiarykeeper.com.",
  },
];

export default function Privacy() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-testid="privacy-page">
      <FadeUp>
        <p className="text-xs uppercase tracking-[0.3em] text-honey-dark mb-6">Legal</p>
        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-forest mb-4" data-testid="privacy-heading">
          Privacy Policy
        </h1>
        <p className="text-sm text-ink/40 mb-12">Last updated: August 2026</p>
      </FadeUp>
      <div className="flex flex-col gap-10">
        {sections.map((s, i) => (
          <FadeUp key={s.title} delay={i * 0.05}>
            <div className="border-t border-forest/15 pt-6" data-testid={`privacy-section-${i + 1}`}>
              <h2 className="font-display text-2xl text-forest mb-3">{s.title}</h2>
              <p className="text-ink/60 leading-relaxed text-sm md:text-base">{s.body}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
